/* Level UP Studio — brand web-kit 2026-10-26.
   Re-colours every LUS stylesheet into the brand palette without editing the 36 original files.
   For each loaded assets/lus-*.css it builds a colour-only copy of its rules (same selectors, same
   !important) and inserts it straight after that <link>, so the cascade order is exactly the original one.
   Loaded as a blocking script after the stylesheets: it runs before first paint, so there is no flash.
   Result is cached in localStorage per stylesheet URL (the ?v= in the URL changes when a file changes).
   Map: dark greys -> brand purples, violet accents -> gold, grey text -> lavender, white text -> cream,
   white-on-violet text -> ink. If this script fails, the site simply keeps its previous colours. */
(function () {
  var SKIP = /lus-(halloween|hw-jack|brand)/;
  var FIX = {'7c5cff':'FFC94F','6e4cff':'E8A63E','9b85ff':'FFDA78','a38cff':'FFDA78','b9a9ff':'FFE7A3','cfc2ff':'DCD3FF','e0a93a':'FFD66E','4fb286':'8DDAC5','12121a':'2B2468','1a1a24':'231D5C','17171f':'211B55','0e0d14':'1C1846','26262f':'3A3380','2a2a36':'3D3685','1f1e30':'322A78','3a2f5e':'5148B0','1a1826':'261F63','f4f4f5':'FFF6E6','c4c4d0':'E6DEFF','ededf2':'FFF6E6','edeaf6':'FFF6E6','f3efff':'FFF6E6','dcd7ea':'E6DEFF','ffffff':'FFF6E6'};
  var VER = 'b3';
  function hsl(r, g, b) {
    r /= 255; g /= 255; b /= 255;
    var mx = Math.max(r, g, b), mn = Math.min(r, g, b), h = 0, s = 0, l = (mx + mn) / 2;
    if (mx !== mn) { var d = mx - mn; s = l > .5 ? d / (2 - mx - mn) : d / (mx + mn);
      h = mx === r ? (g - b) / d + (g < b ? 6 : 0) : mx === g ? (b - r) / d + 2 : (r - g) / d + 4; h *= 60; }
    return [h, s, l];
  }
  function fromHsl(h, s, l) {
    function k(n) { return (n + h / 30) % 12; }
    var a = s * Math.min(l, 1 - l);
    function f(n) { return l - a * Math.max(-1, Math.min(k(n) - 3, Math.min(9 - k(n), 1))); }
    return [f(0), f(8), f(4)].map(function (x) { return Math.round(x * 255); });
  }
  function hex(c) { return '#' + c.map(function (x) { return (x < 16 ? '0' : '') + x.toString(16); }).join('').toUpperCase(); }
  function out(c, a) { return a >= 1 ? hex(c) : 'rgba(' + c.join(',') + ',' + (+a.toFixed(3)) + ')'; }
  function map(r, g, b, a, T) {
    var key = hex([r, g, b]).slice(1).toLowerCase();
    if (r === 255 && g === 255 && b === 255 && a < 1) return null;
    if (r === 0 && g === 0 && b === 0) return out([8, 5, 30], a);
    if (FIX[key]) { var v = FIX[key]; return out([parseInt(v.substr(0, 2), 16), parseInt(v.substr(2, 2), 16), parseInt(v.substr(4, 2), 16)], a); }
    var x = hsl(r, g, b), h = x[0], s = x[1], l = x[2];
    if (T && s < 0.25) { if (l > 0.88) return out([255, 246, 230], a);
      return out(fromHsl(250, 0.5, Math.max(0.64, Math.min(0.92, 0.64 + (l - 0.35) * 0.55))), a); }
    if (s < 0.2 || (h >= 225 && h <= 290 && l < 0.3)) {
      if (l < 0.5) return out(fromHsl(248, 0.5, Math.max(0.12, Math.min(0.34, 0.16 + (l - 0.04) * 0.8))), a);
      if (l > 0.88) return out([255, 246, 230], a);
      return out(fromHsl(250, 0.55, Math.min(0.9, l + 0.08)), a);
    }
    if (h >= 225 && h <= 290) { if (l < 0.7) return out([255, 201, 79], a); if (l < 0.8) return out([255, 218, 120], a); return out([220, 211, 255], a); }
    return null;
  }
  var RE = /#([0-9a-fA-F]{6}|[0-9a-fA-F]{3})\b|rgba?\(\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*([\d.]+%?)\s*)?\)/g;
  var ACC = /--vio\b|#7c5cff|#6e4cff|#9b85ff|#a38cff|rgba?\(\s*124\s*,\s*92\s*,\s*255\s*(,\s*(1|0?\.[89]\d*))?\)|var\(--violet/i;
  var TXT = /^(color|fill|-webkit-text-fill-color|caret-color|text-decoration-color)$|^--(tx|text|cc-text|cc-muted|muted)/;
  function tx(v, T) {
    var ch = false;
    var nv = v.replace(RE, function (m, hx, r, g, b, a) {
      var R, G, B, A = 1;
      if (hx) { if (hx.length === 3) hx = hx.replace(/(.)/g, '$1$1');
        R = parseInt(hx.substr(0, 2), 16); G = parseInt(hx.substr(2, 2), 16); B = parseInt(hx.substr(4, 2), 16); }
      else { R = +r; G = +g; B = +b; if (a != null) A = /%$/.test(a) ? parseFloat(a) / 100 : +a; }
      var o = map(R, G, B, A, T);
      if (!o) return m;
      if (o.toLowerCase() !== m.toLowerCase()) ch = true;
      return o;
    });
    return ch ? nv : null;
  }
  function decls(t) {
    var res = [], depth = 0, cur = '', i, c;
    function push(x) {
      var k = x.indexOf(':'); if (k < 0) return;
      var p = x.slice(0, k).trim(), v = x.slice(k + 1).trim(), imp = /!\s*important\s*$/i.test(v);
      if (p.slice(0, 2) !== '--') p = p.toLowerCase();
      if (imp) v = v.replace(/!\s*important\s*$/i, '').trim();
      if (p) res.push([p, v, imp]);
    }
    for (i = 0; i < t.length; i++) {
      c = t[i];
      if (c === '(') depth++; else if (c === ')') depth--;
      if (c === ';' && depth === 0) { push(cur); cur = ''; } else cur += c;
    }
    push(cur);
    return res;
  }
  function walk(rules) {
    var s = '';
    for (var i = 0; i < rules.length; i++) {
      var r = rules[i];
      if (r.type === 1) {
        /* Longhands as the CSSOM gives them. A shorthand that uses var(), e.g.
           background: linear-gradient(var(--vio,#7C5CFF) ...), leaves its longhands empty,
           so those are taken from cssText instead (only when they contain var()). */
        var st = r.style, list = [], seen = {}, d = '', acc = false, j, p, v;
        for (j = 0; j < st.length; j++) { p = st[j]; v = st.getPropertyValue(p);
          if (v) { seen[p] = 1; list.push([p, v, !!st.getPropertyPriority(p)]); } }
        var ds = decls(st.cssText);
        for (j = 0; j < ds.length; j++) if (!seen[ds[j][0]] && ds[j][1].indexOf('var(') >= 0) list.push(ds[j]);
        for (j = 0; j < list.length; j++) if (/^background/.test(list[j][0]) && ACC.test(list[j][1]) && !/transparent/.test(list[j][1])) acc = true;
        for (j = 0; j < list.length; j++) {
          p = list[j][0];
          var nv = tx(list[j][1], TXT.test(p));
          if (p === 'color' && acc) nv = '#241F45';
          if (p === '--cc-ink') nv = '#241F45';
          if (nv != null) d += p + ':' + nv + (list[j][2] ? '!important' : '') + ';';
        }
        if (d) s += r.selectorText + '{' + d + '}';
      } else if (r.type === 4) { var m = walk(r.cssRules); if (m) s += '@media ' + r.media.mediaText + '{' + m + '}'; }
      else if (r.type === 12) { var u = walk(r.cssRules); if (u) s += '@supports ' + r.conditionText + '{' + u + '}'; }
    }
    return s;
  }
  function apply(link) {
    if (link.__lvl || !/\/assets\/lus-[\w-]+\.css/.test(link.href) || SKIP.test(link.href)) return;
    var key = 'lvlb:' + VER + ':' + link.href.split('/assets/')[1], css = null;
    try { css = localStorage.getItem(key); } catch (e) {}
    if (css == null) {
      try { css = walk(link.sheet.cssRules); } catch (e) { return; }
      try { localStorage.setItem(key, css); } catch (e) {}
    }
    link.__lvl = 1;
    if (!css) return;
    var el = document.createElement('style');
    el.setAttribute('data-lvl', link.href.split('/assets/')[1].split('.css')[0]);
    el.textContent = css;
    link.parentNode.insertBefore(el, link.nextSibling);
  }
  function scan() { var ls = document.querySelectorAll('link[rel="stylesheet"]'); for (var i = 0; i < ls.length; i++) if (ls[i].sheet) apply(ls[i]); }
  scan();
  try {
    new MutationObserver(function (ms) {
      ms.forEach(function (m) { m.addedNodes.forEach(function (n) {
        if (n.tagName === 'LINK' && n.rel === 'stylesheet') { if (n.sheet) apply(n); else n.addEventListener('load', function () { apply(n); }); }
      }); });
    }).observe(document.documentElement, { childList: true, subtree: true });
  } catch (e) {}
  document.addEventListener('DOMContentLoaded', scan);
})();
